import React, { useState } from "react";
import { Card, CardContent, CardMedia, Typography, Button, Grid, Box, CircularProgress } from "@mui/material";
import SubquestionCard from "../SubquestionCard/SubquestionCard";
import './QuestionCard.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from "react-router-dom";
import useAxios from "../../../../hooks/useAxios";
import AddIcon from "@mui/icons-material/Add";
import MathPreview from "../../../CustomInputFields/MathPreview/MathPreview";

const QuestionCard = ({ question, handleDelete, handleUpdate }) => {
    const { id, body, correct_answer, image, choices, grade, subquestions } = question;
    const navigate = useNavigate();
    const axiosInstance = useAxios();

    // State for loading status
    const [loadingSubquestion, setLoadingSubquestion] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');

    const handleUpdateSubquestion = (id) => {
        navigate(`/update-subquestion/${question.id}/${id}`);
    };

    const handleDeleteSubquestion = async (id) => {
        try {
            setLoadingSubquestion(true);
            setLoadingMessage('Deleting subquestion...');
            const response = await axiosInstance.delete(`/quizzes/questions/${question.id}/subquestions/${id}`);
            if (response.data.success) {
                setLoadingMessage('');
                window.location.reload(); // Reload the page after successful deletion
            }
        } catch (err) {
            console.error("Error deleting subquestion:", err);
            setLoadingMessage('An error occurred while deleting.');
        } finally {
            setLoadingSubquestion(false);
        }
    };

    return (
        <Card className="question-card">
            <CardContent>
                {/* <Typography className="question-title" gutterBottom>
                    {body}
                </Typography> */}
                <MathPreview text={body} />
                <Typography className="question-correct-answer" gutterBottom>
                {correct_answer?  'Correct Answer: '.correct_answer : ''}
                </Typography>

                {image && (
                <CardMedia
                    component="img"
                    className="question-image"
                    image={`${process.env.REACT_APP_API_BASE_IMAGE_URL}${image}`}
                    alt="Question Image"
                />
                )}

                <Typography className="grade-text">
                    Grade: {Number.isInteger(grade) ? grade : grade?.toFixed(1)}
                </Typography>

                {choices?.length > 0 && (
                <Box className="choices-container">
                    <Typography className="question-text" fontWeight="bold">
                    Choices:
                    </Typography>
                    {choices.map((choice, index) => (
                    <Typography key={index} className="choice-item">
                      {<MathPreview text={`${choice.number}.   ${choice.value}`} />}
                    </Typography>
                    ))}
                </Box>
                )}

                <div className="action-buttons">
                    <Button
                        className="primary-button"
                        onClick={() => handleUpdate(id)}
                    >
                        <EditIcon 
                            className="edit-icon"
                        />
                        Edit
                    </Button>
                    <Button
                        className="delete-button"
                        onClick={() => handleDelete(id)}
                    >
                        <DeleteIcon 
                            className="delete-icon"
                        />
                        Delete
                    </Button>
                </div>

                {subquestions.length > 0 && (
                <Box className="subquestions-container">
                    <Typography className="subquestions-title">
                    Subquestions:
                    </Typography>
                    {subquestions.map((subquestion) => (
                    <SubquestionCard
                        key={subquestion.id}
                        subquestion={subquestion}
                        handleDelete={() => handleDeleteSubquestion(subquestion.id)}
                        handleUpdate={() => handleUpdateSubquestion(subquestion.id)}
                    />
                    ))}
                </Box>
                )}
                <Button
                    className="text-button add-subquestion-button"
                    onClick={() => navigate(`/questions/${question.id}/add-subquestion`)}
                >
                <AddIcon 
                    className="delete-icon"
                />
                Add Subquestion
                </Button>
            </CardContent>

            {/* Loading Indicator */}
            {loadingSubquestion && (
                <Box className="loading-indicator" textAlign="center" mt={2}>
                    <CircularProgress />
                    <Typography variant="body2" mt={1}>
                        {loadingMessage}
                    </Typography>
                </Box>
            )}
        </Card>
    );
};

export default QuestionCard;
